import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { RegistrationProvider } from './Hooks/Context/Registration/RegistrationContext';
import { UserProvider } from './Hooks/Context/UserDetails/UserContext';
import { lazy, Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { SkeletonLoader } from './Components/Common/Skeleton/SkeletonLoader';
const App = lazy(() => import('./App'))
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={<SkeletonLoader />}>
      <RegistrationProvider>
        <UserProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </UserProvider>
      </RegistrationProvider>
    </Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
